/* Da Mirella — apparitions douces au scroll (respecte prefers-reduced-motion) */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var targets = document.querySelectorAll('.dm-section .dm-container, .dm-hero__content, .dm-banner__content');
  if (!('IntersectionObserver' in window) || targets.length === 0) return;
  targets.forEach(function (el) { el.classList.add('dm-reveal'); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('dm-reveal--visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  targets.forEach(function (el) { io.observe(el); });
})();
